import { RootState } from '@/store/types';
import { Target, TargetState } from '@/store/modules/target/types';
import { Module, GetterTree, MutationTree, ActionTree } from 'vuex';
import { targetAPI, UpdateTargetForm } from '@/api/target';
import { ElMessage } from 'element-plus';

export const moduleName = "target";

export enum TargetGetters {
    getTargetList = "GET_TARGET_LIST",
    getLoading = "GET_LOADING",
}

export enum TargetMutations {
    setTargetList = "SET_TARGET_LIST",
    setLoading = "SET_LOADING",
}

export enum TargetActions {
    asyncGetTargetList = "ASYNC_GET_TARGET_LIST",
    asyncUpdateTarget = "ASYNC_UPDATE_TARGET",
    asyncDeleteTarget = "ASYNC_DELETE_TARGET",
}

const state: TargetState = {
    targets: [],
    isLoading: false,
}

export const getters: GetterTree<TargetState, RootState> = {
    [TargetGetters.getTargetList](state): Target[] {
        return state.targets;
    },
    [TargetGetters.getLoading](state): boolean {
        return state.isLoading;
    },

}

const mutations: MutationTree<TargetState> = {
    [TargetMutations.setTargetList](state, payload: Target[]): void {
        state.targets = payload;
    },
    [TargetMutations.setLoading](state, payload: boolean): void {
        state.isLoading = payload;
    },
}

const actions: ActionTree<TargetState, RootState> = {
    async [TargetActions.asyncGetTargetList]({ commit }, id: string): Promise<void> {
        try {
            commit(TargetMutations.setLoading, true);
            const targetList = await targetAPI.getTargetListByProjId(id);
            commit(TargetMutations.setTargetList, targetList);
        } catch (err) {
            console.log(err)
        } finally {
            commit(TargetMutations.setLoading, false);
        }
    },
    async [TargetActions.asyncUpdateTarget]({ commit }, updateTargetMsg: UpdateTargetForm): Promise<boolean> {
        try {
            commit(TargetMutations.setLoading, true);
            const res = await targetAPI.updateTarget(updateTargetMsg);
            ElMessage({
                message: '编辑成功',
                type: 'success',
            })
            const TargetList = await targetAPI.getTargetListByProjId(res.projId)
            commit(TargetMutations.setTargetList, TargetList);
            return true
        } catch (err) {
            console.log(err)
            return false
        } finally {
            commit(TargetMutations.setLoading, false);
        }
    },
    async [TargetActions.asyncDeleteTarget]({ commit }, { projId, uid }: { projId: string, uid: string })
        : Promise<boolean> {
        try {
            commit(TargetMutations.setLoading, true);
            const res = await targetAPI.deleteTarget(projId, uid);
            ElMessage({
                message: '删除成功',
                type: 'success',
            })
            const TargetList = await targetAPI.getTargetListByProjId(res.projId)
            commit(TargetMutations.setTargetList, TargetList);
            return true
        } catch (err) {
            console.log(err)
            return false
        } finally {
            commit(TargetMutations.setLoading, false);
        }
    },
}

export const target: Module<TargetState, RootState> = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}
